module.exports = __webpack_public_path__ + "img/gps_ios_safari.53f8312a.jpg";